"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var ImageStatusFavorite_1 = __importDefault(require("./ImageStatusFavorite"));
var MerchTile_styles_1 = require("./MerchTile.styles");
var PricingAndTerms_1 = __importDefault(require("./PricingAndTerms"));
var YMMTM_1 = __importDefault(require("./YMMTM"));
var ShippingAndGetItBy_1 = __importDefault(require("../ShippingAndGetItBy"));
var DealTags_1 = __importDefault(require("../Tags/DealTags/DealTags"));
var TileDataContext_1 = require("../TileDataContext");
//props needed for MerchTilePlayGround:
// nativePayload and handleTileClick and href
//TODO figure out if this style is really needed or if we okay with the space always being there '44px_1fr_auto'(no tags)
function MerchTile() {
    return (react_1.default.createElement("div", { "data-package": "merch-tile" },
        react_1.default.createElement(MerchTile_styles_1.TileContainer, null,
            react_1.default.createElement("a", { 
                // href={href}
                onClick: function () { return console.log('clicked tile'); }, "data-analytics-id": "result-tile-v2" },
                react_1.default.createElement(MerchTile_styles_1.TileContentWrapper, null,
                    react_1.default.createElement(ImageStatusFavorite_1.default, null),
                    react_1.default.createElement(MerchTile_styles_1.LowerContentWrapper, null,
                        react_1.default.createElement(DealTags_1.default, null),
                        react_1.default.createElement(YMMTM_1.default, null),
                        react_1.default.createElement(PricingAndTerms_1.default, null),
                        react_1.default.createElement(ShippingAndGetItBy_1.default, null)))))));
}
function MerchTileContainer(props) {
    return (react_1.default.createElement(TileDataContext_1.TileDataContextProvider, { tileData: props.tileData, availabilityInfo: props.availabilityInfo, financeInfo: props.financeInfo, assets: props.assets, userInfo: props.userInfo, utils: props.utils },
        react_1.default.createElement(MerchTile, null)));
}
exports.default = MerchTileContainer;
//# sourceMappingURL=MerchTile.js.map